import * as React from "react";
import classNames from "classnames";
import { OverlayTrigger } from "components/common";
const ShardRouting = ({ route }) => {
  const tooltip = /* @__PURE__ */ React.createElement(React.Fragment, null, "State: ", /* @__PURE__ */ React.createElement("i", null, route.state), " on ", route.node_hostname, " (", route.node_name, ")");
  return /* @__PURE__ */ React.createElement("li", { className: classNames("shard", `shard-${route.state}`, { "shard-primary": route.primary }) }, /* @__PURE__ */ React.createElement(OverlayTrigger, { placement: "top", overlay: tooltip }, /* @__PURE__ */ React.createElement("span", { className: "id" }, "S", route.id)));
};
export default ShardRouting;
